(() => {
  const BLOCK_SELECTOR = '.product-block';
  const SCOPE_SELECTOR = '.product-block-container';

  function placeEventFields(scope) {
    if (scope.querySelector('.att-event-details-row')) return;

    const dateInput = scope.querySelector(
      '.js-date-input[name="properties[Event Date]"]'
    );
    const eventType = scope.querySelector(
      'select[name="properties[Event Type]"]'
    );

    if (!dateInput || !eventType) return;

    const dateBlock = dateInput.closest(BLOCK_SELECTOR);
    const typeBlock = eventType.closest(BLOCK_SELECTOR);

    if (!dateBlock || !typeBlock || dateBlock.parentElement !== typeBlock.parentElement) {
      return;
    }

    const row = document.createElement('div');
    row.className = 'att-event-details-row';
    dateBlock.parentElement.insertBefore(row, dateBlock);
    row.append(dateBlock, typeBlock);
  }

  function placeQuantityBesideButton(scope) {
    const quantityInput = scope.querySelector('input[name="quantity"]');
    const addToCartButton = scope.querySelector('.add-to-cart-btn');

    if (!quantityInput || !addToCartButton) return;

    const quantityBlock = quantityInput.closest(BLOCK_SELECTOR);
    const productForm = addToCartButton.closest('form');
    const buttonCell = addToCartButton.parentElement;

    if (!quantityBlock || !productForm || !buttonCell) return;

    let row = scope.querySelector('.att-purchase-row');

    if (!row) {
      row = document.createElement('div');
      row.className = 'att-purchase-row';
      buttonCell.classList.add('att-add-to-cart-cell');

      buttonCell.parentElement.insertBefore(row, buttonCell);
      row.append(quantityBlock, buttonCell);
    }

    /* Move the existing Shopify payment-terms line below the purchase row. */
    const paymentTerms = productForm.querySelector('shopify-payment-terms');
    const paymentTermsWrapper = paymentTerms?.closest('div');

    if (paymentTermsWrapper && !paymentTermsWrapper.classList.contains('att-payment-terms-below')) {
      paymentTermsWrapper.classList.add('att-payment-terms-below');
      row.insertAdjacentElement('afterend', paymentTermsWrapper);
    }
  }

  function initialize(root = document) {
    const scopes = [];

    if (root.matches?.(SCOPE_SELECTOR)) scopes.push(root);
    root.querySelectorAll?.(SCOPE_SELECTOR).forEach((scope) => scopes.push(scope));

    scopes.forEach((scope) => {
      placeEventFields(scope);
      placeQuantityBesideButton(scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  /* Re-run when Shopify reloads a section inside the theme editor. */
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
